import { UserId } from '@/portainer/users/types';
import { AccessTokensDatatable } from '@/react/portainer/account/AccountView/AccessTokensDatatable';

import { TextTip } from '@@/Tip/TextTip';
import { Widget, WidgetBody } from '@@/Widget';

export function TokensTab({
  userId,
  isSelf,
  canSeeTokens,
}: {
  userId: UserId;
  isSelf: boolean;
  canSeeTokens: boolean;
}) {
  if (!canSeeTokens) {
    return (
      <div className="row">
        <div className="col-sm-12">
          <Widget>
            <WidgetBody>
              <TextTip color="blue">
                An administrator&apos;s access tokens are visible only to that
                administrator.
              </TextTip>
            </WidgetBody>
          </Widget>
        </div>
      </div>
    );
  }

  return (
    <AccessTokensDatatable
      userId={userId}
      showAdd={isSelf}
      addTo="portainer.account.new-access-token"
    />
  );
}
